import Decorator from './decorator'

export default class DocketDecorator extends Decorator {
  number () {
    return `#${this.decorated.number}`
  }

  weight () {
    return `${this.decorated.weight}t`
  }

  statusText () {
    if (this.decorated.status === 'pending') {
      return 'Pending'
    } else if (this.decorated.status === 'resubmit') {
      return 'Resubmit'
    } else if (this.decorated.status === 'approved') {
      return 'Approved'
    }
  }

  statusClass () {
    if (this.decorated.status === 'pending') {
      return 'text-info'
    } else if (this.decorated.status === 'resubmit') {
      return 'text-danger'
    } else if (this.decorated.status === 'approved') {
      return 'text-success'
    }
  }
}



// WEBPACK FOOTER //
// ./src/decorators/docket.js